// extracted by mini-css-extract-plugin
var _1 = "_ylFDW";
var _2 = "_cTJPQ";
var _3 = "_f4i4o";
var _4 = "_Wv_yU";
var _5 = "_YoQg2";
var _6 = "_oN0wZ";
export { _1 as "activeTab", _2 as "childrenContainer", _3 as "disabledTab", _4 as "tab", _5 as "tabs", _6 as "tabsContainer" }
